import * as React from 'react';
import { MarketLink } from '@market/react';
import { PlayCircle } from '../icons';

interface Props {
  text: string;
  url: string;
}
export const TitleHelpBlock = ({ text, url }: Props) => {
  return text ? (
    <div className="tw-mt-1 tw-flex tw-items-center">
      <PlayCircle />
      <span className="tw-ml-2">
        Need help?{' '}
        <MarketLink href={url} target="_blank" rel="noreferrer">
          {text}
        </MarketLink>
      </span>
    </div>
  ) : null;
};
